import React, { TextareaHTMLAttributes } from 'react';

import { Container, TextAreaInput } from './styles';

const TextArea = ({ ...rest }: TextareaHTMLAttributes<HTMLTextAreaElement>) => {
  return (
    <Container>
      <TextAreaInput {...rest} />
    </Container>
  );
};

export default TextArea;
